module.exports = __webpack_public_path__ + "img/banner1.c415aca1.jpg";